<app-error>
  <div class="description">{{ 'general.somethingWentWrong' | translate }}</div>
  <div class="description">
    {{ 'general.goBackToThePreviousScreen' | translate }}
  </div>
</app-error>
